import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-database-design-dev',
  templateUrl: './database-design-dev.component.html',
  styleUrls: ['./database-design-dev.component.css']
})
export class DatabaseDesignDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/database-design-dev/database-design-dev.component.ts